var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { ReactiveXa } from '../../../api/ReactiveXa';
import { xa } from '../../../../utils/xa/xa';
export class HistoryDbMicroAnswers {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get history() {
        return this.parent;
    }
    get app() {
        return this.history.app;
    }
    get microAnswersBeforePageLoad() {
        return this.microAnswersQuery.streamedValue;
    }
    get areMicroAnswersAvailable() {
        return this.microAnswersQuery.isAvailable;
    }
    get microAnswersQuery() {
        return new ReactiveXa({
            xa: () => {
                return xa.topic.getMicroAnswersOfTopic({});
            },
            defaultValue: [],
        });
    }
}
__decorate([
    memoize
], HistoryDbMicroAnswers.prototype, "microAnswersQuery", null);
